import { type LogtoConfig, LogtoProvider } from '@logto/react';
import type { FC, PropsWithChildren } from 'react';

const config: LogtoConfig = {
  endpoint: import.meta.env.VITE_LOGTO_ENDPOINT,
  appId: import.meta.env.VITE_LOGTO_APP_ID,
  resources: [import.meta.env.VITE_LOGTO_API_RESOURCE],
  scopes: ['openid', 'email', 'profile'],
};

function isTestMode(): boolean {
  return typeof window !== 'undefined' && '__TEST_AUTH__' in (window as unknown as Record<string, unknown>);
}

export const LogtoProviderWrapper: FC<PropsWithChildren> = ({ children }) => {
  if (isTestMode()) {
    return <>{children}</>;
  }
  return <LogtoProvider config={config}>{children}</LogtoProvider>;
};
